import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { ActionService } from "../services/action.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  public constructor(
    protected router: Router,
    protected service: ActionService
  ) {}

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const ret =
      this.service.client.Token &&
      this.service.client.Token.length > 0 &&
      this.service.client.Token != "null";
    if (ret) {
      return true;
    } else {
      this.router.navigate(["/login"], { replaceUrl: true });
      return false;
    }
  }
}
